import {useNavigate} from 'react-router-dom';
import {FlexiCloseButton} from '@flexinet/ui-components';

import {useAllowedActions} from '../../../hooks/useAllowedActions';
import {EditRecordButton} from '../buttons/EditRecordButton';
import {Product} from '../types';
import config from '../config';

// Header actions of the detail page. Edit is hidden, not disabled, without
// UpdateProduct.
export const useEditPageTools = (record?: Product) => {
    const navigate = useNavigate();
    const {allowedActions} = useAllowedActions();

    const tools = [];

    if (record && allowedActions.includes('UpdateProduct')) {
        tools.push(<EditRecordButton key='edit' record={record}/>);
    }

    tools.push(<FlexiCloseButton key='close' onClick={() => navigate(config.basePath)}/>);

    return {tools};
};
